/**
 * Page résultats pneus (Partie 3) — vanilla JS, zéro dépendance, même esprit que
 * devis-widget.js. Le 1er lot du catalogue (≤250 produits, avec tous les metafields) est déjà
 * embarqué côté serveur par sections/pneus-resultats.liquid dans #pneus-catalogue-data. Si
 * `data-total-pages` (posé par ce même fichier Liquid, plafonné à 250 produits/page par Shopify)
 * indique plus d'une page, les pages suivantes sont récupérées ici via l'API de rendu de section
 * Shopify (fetch ?page=N&section_id=...) avant tout filtrage/affichage — seul cas où ce fichier
 * fait un appel réseau.
 *
 * Unités : `price` (prix du produit Shopify) est en centimes ; `prix_montage` (metafield Money)
 * est une chaîne décimale (ex. "17.95") — ne jamais les additionner sans diviser `price` par 100
 * d'abord.
 *
 * Ajout au panier (bouton "Ajouter") : VRAI panier Shopify, pas le panier de devis. Les pneus ont
 * un parcours d'achat séparé — panier Shopify et paiement intégral en ligne — alors que le widget
 * de devis reste le chemin des autres prestations et des dimensions absentes du catalogue (bouton
 * "Demander cette dimension" de l'état vide, plus bas, qui lui n'a pas bougé).
 *
 * Chaque carte porte le choix du client : "Montage à l'atelier" (coché par défaut) ou "Retrait
 * seul". Montage choisi = le pneu ET le produit "Montage pneu" partent dans le MÊME appel à
 * /cart/add.js, même quantité. Retrait seul = le pneu seul. Le choix voyage ensuite avec la ligne
 * de panier, dans une propriété de ligne Shopify.
 *
 * Les libellés, le prix du montage et le calcul de la date de disponibilité ne sont PAS définis
 * ici : ils viennent de window.MautoPneu (assets/mauto-montage-pneu.js), pour que la fiche
 * produit et cette page ne puissent pas afficher deux choses différentes. Ce même fichier reprend
 * la main sur toute modification ultérieure du panier (quantité changée, pneu retiré).
 */
(function () {
  'use strict';

  // Les saisons proposées au filtre sont celles RÉELLEMENT présentes dans les résultats, pas une
  // liste figée. Le catalogue ne contient que de l'Été au 11/09/2026 : proposer « Hiver » et
  // « 4 saisons » donnait un filtre qui ne ramenait jamais rien — le client croit le site cassé.
  // Elles réapparaîtront d'elles-mêmes le jour où un pneu hiver sera publié, sans retoucher ce
  // fichier. L'entrée « Toutes » n'est pas une saison mais l'absence de filtre : c'est l'option
  // vide du menu, elle ne se déduit donc pas du catalogue.
  // (L'ancienne liste contenait d'ailleurs « Toutes » en plus de l'option vide, ce qui affichait
  // deux fois la même entrée.)
  function saisonsDisponibles(list) {
    var vues = {}, out = [];
    list.forEach(function (p) {
      var s = String(p.saison || '').trim();
      if (s && !vues[s]) { vues[s] = true; out.push(s); }
    });
    out.sort();
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Icônes au trait, communes à tout le parcours (assets/mauto-icones.js). Chaîne vide si le
  // fichier partagé n'a pas pu se charger : le message reste lisible sans son pictogramme.
  function icone(cle) {
    var m = window.MautoIcones;
    return m ? m.pour(cle) : '';
  }

  function euros(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function readCatalogue() {
    var el = document.getElementById('pneus-catalogue-data');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function parseCatalogueFromHtml(html) {
    var match = html.match(/<script[^>]*id="pneus-catalogue-data"[^>]*>([\s\S]*?)<\/script>/);
    if (!match) return [];
    try {
      var data = JSON.parse(match[1]);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function fetchCataloguePage(pageNumber, sectionId) {
    var sep = window.location.search ? '&' : '?';
    var url = window.location.pathname + window.location.search + sep + 'page=' + pageNumber + '&section_id=' + encodeURIComponent(sectionId);
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(parseCatalogueFromHtml)
      .catch(function () { return []; }); // page suivante indisponible — on affiche ce qu'on a déjà plutôt que de bloquer
  }

  // Le catalogue peut dépasser la limite Shopify de 250 produits/page (`paginate`) : au-delà de
  // la 1re page déjà embarquée dans le HTML, on va chercher les pages restantes en parallèle.
  function loadFullCatalogue(root, firstPage) {
    var totalPages = parseInt(root.getAttribute('data-total-pages'), 10) || 1;
    var sectionId = root.getAttribute('data-section-id');
    if (totalPages <= 1 || !sectionId) {
      return Promise.resolve(firstPage);
    }
    var pending = [];
    for (var p = 2; p <= totalPages; p++) {
      pending.push(fetchCataloguePage(p, sectionId));
    }
    return Promise.all(pending).then(function (pages) {
      return pages.reduce(function (all, page) { return all.concat(page); }, firstPage.slice());
    });
  }

  function readParams() {
    var p = new URLSearchParams(window.location.search);
    return {
      largeur: p.get('largeur') || '',
      hauteur: p.get('hauteur') || '',
      diametre: p.get('diametre') || '',
      saison: p.get('saison') || '',
      charge: p.get('charge') || '',
      vitesse: p.get('vitesse') || '',
      // Défaut 2, comme la fiche produit : le paramètre est absent dès que le client n'a pas
      // choisi de quantité dans le tiroir, et c'est le cas le plus fréquent.
      quantite: p.get('quantite') || '2',
    };
  }

  function matchesDimension(p, dims) {
    return String(p.largeur) === String(dims.largeur) &&
      String(p.hauteur) === String(dims.hauteur) &&
      String(p.diametre) === String(dims.diametre);
  }

  // Échelle des indices de vitesse, dans l'ordre CROISSANT. Attention : l'ordre n'est pas
  // alphabétique — H se place entre U et V. Toute comparaison doit passer par ce rang.
  var VITESSE_RANG = { Q: 1, R: 2, S: 3, T: 4, U: 5, H: 6, V: 7, W: 8, Y: 9 };
  function rangVitesse(v) {
    return VITESSE_RANG[String(v || '').trim().toUpperCase()] || 0;
  }

  // Compare un pneu à la demande du client, à dimension déjà identique (la dimension ne se
  // substitue JAMAIS : elle dépend de la jante et du diamètre de roulement).
  //   'exact'     → les deux indices correspondent
  //   'superieur' → les deux indices sont >= au besoin, donc montable
  //   null        → incompatible, ou indice manquant côté produit
  // Les deux conditions doivent être vraies SIMULTANÉMENT : un 109H face à une demande 101W a
  // bien une charge supérieure (109 >= 101) mais une vitesse inférieure (H < W) — il est exclu.
  function compatibiliteIndices(p, dims) {
    var dc = dims.charge ? parseInt(dims.charge, 10) : null;
    var dv = dims.vitesse ? rangVitesse(dims.vitesse) : null;
    if (dc === null && dv === null) return 'exact';
    var pc = parseInt(p.indice_charge, 10);
    var pv = rangVitesse(p.indice_vitesse);
    // Un pneu dont l'indice utile manque n'est jamais proposé : on n'affirme pas une
    // compatibilité qu'on n'est pas capable de vérifier.
    if (dc !== null && !(pc > 0)) return null;
    if (dv !== null && pv === 0) return null;
    if (dc !== null && pc < dc) return null;
    if (dv !== null && pv < dv) return null;
    var exact = (dc === null || pc === dc) && (dv === null || pv === dv);
    return exact ? 'exact' : 'superieur';
  }

  // "son indice de vitesse est supérieur" / "ses indices de charge et de vitesse sont supérieurs"
  function libelleIndicesSuperieurs(p, dims) {
    var chargeSup = dims.charge && parseInt(p.indice_charge, 10) > parseInt(dims.charge, 10);
    var vitesseSup = dims.vitesse && rangVitesse(p.indice_vitesse) > rangVitesse(dims.vitesse);
    if (chargeSup && vitesseSup) return 'ses indices de charge et de vitesse sont supérieurs';
    if (chargeSup) return 'son indice de charge est supérieur';
    return 'son indice de vitesse est supérieur';
  }

  // Demande de commande, dimension déjà pré-remplie : le client ne ressaisit rien.
  function lienCommande(dims) {
    var params = new URLSearchParams();
    params.set('largeur', dims.largeur);
    params.set('hauteur', dims.hauteur);
    params.set('diametre', dims.diametre);
    if (dims.charge) params.set('charge', dims.charge);
    if (dims.vitesse) params.set('vitesse', dims.vitesse);
    if (dims.saison) params.set('saison', dims.saison);
    if (dims.quantite) params.set('quantite', dims.quantite);
    params.set('commande', '1');
    return '/pages/devis-en-ligne?' + params.toString();
  }

  function distinctMarques(list) {
    var seen = {};
    var out = [];
    list.forEach(function (p) {
      if (p.marque && !seen[p.marque]) { seen[p.marque] = true; out.push(p.marque); }
    });
    out.sort();
    return out;
  }

  // Explication des indices supérieurs, dans le même esprit que la pop-up "Renforcé (XL)" de la
  // fiche produit : on explique pourquoi c'est compatible, sans affirmer une équivalence.
  function ouvrirInfoIndices(p, dims) {
    var existante = document.querySelector('.pneus-modal-backdrop');
    if (existante) existante.remove();
    var dim = esc(dims.largeur) + '/' + esc(dims.hauteur) + ' R' + esc(dims.diametre);
    var back = document.createElement('div');
    back.className = 'pneus-modal-backdrop';
    back.innerHTML =
      '<div class="pneus-modal" role="dialog" aria-label="Indices supérieurs">' +
        '<button type="button" class="pneus-modal-close" aria-label="Fermer">✕</button>' +
        '<p class="pneus-modal-title">Indices supérieurs — compatible</p>' +
        '<p>Vous recherchez du ' + dim + ' ' + esc(dims.charge) + esc(dims.vitesse) + '. ' +
          'Ce pneu est en ' + esc(p.indice_charge) + esc(p.indice_vitesse) + ' : sa dimension est identique et ' +
          libelleIndicesSuperieurs(p, dims) + ', il se monte donc sans problème sur votre véhicule. ' +
          'Un indice supérieur n\'est jamais un défaut.</p>' +
        '<p>Si votre constructeur impose un indice précis, vérifiez le carnet d\'entretien.</p>' +
      '</div>';
    function fermer() { back.remove(); }
    back.addEventListener('click', function (e) { if (e.target === back) fermer(); });
    back.querySelector('.pneus-modal-close').addEventListener('click', fermer);
    document.body.appendChild(back);
  }

  function afficherToast(texte, erreur) {
    var existing = document.querySelector('.pneus-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'pneus-toast' + (erreur ? ' pneus-toast--erreur' : '');
    toast.innerHTML =
      '<span>' + (erreur ? icone('alerte') : icone('valide')) + esc(texte) + '</span>' +
      (erreur ? '' : '<button type="button">Voir mon panier</button>');
    document.body.appendChild(toast);
    var bouton = toast.querySelector('button');
    if (bouton) {
      bouton.addEventListener('click', function () { window.location.href = '/cart'; });
    }
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 8000);
  }

  // Réglages partagés avec la fiche produit (assets/mauto-montage-pneu.js). Absents seulement si
  // ce fichier n'a pas pu se charger : on retombe alors sur des libellés équivalents plutôt que
  // d'afficher des cartes trouées.
  function options() {
    return window.MautoPneu || null;
  }
  function libelleMontage() {
    var o = options();
    return (o && o.libelleMontage) || 'Montage à l\'atelier';
  }
  function libelleRetrait() {
    var o = options();
    return (o && o.libelleRetrait) || 'Retrait seul';
  }
  function texteDisponibilite(avecMontage) {
    var o = options();
    return o ? o.texteDisponibilite(avecMontage) : '';
  }
  // Prix réellement facturé = celui du produit "Montage pneu". Le metafield prix_montage de la
  // fiche ne sert que de repli : c'est lui qui, historiquement, pouvait diverger du prix encaissé.
  function prixMontage(p) {
    var o = options();
    if (o && o.prixMontageCents) return o.prixMontageCents / 100;
    return p.prix_montage ? parseFloat(p.prix_montage) : 0;
  }

  // Montage choisi : le pneu et son montage dans un seul appel, pour que le panier ne montre
  // jamais des pneus sans leur montage, même le temps d'un aller-retour réseau. Retrait seul :
  // le pneu part seul. Dans les deux cas la ligne porte le choix, qui reste lisible par l'atelier
  // sur la commande.
  function ajouterAuPanier(product, qte, avecMontage) {
    if (!product.variant_id) {
      return Promise.reject(new Error('Ce pneu n\'a pas pu être identifié. Rechargez la page et réessayez.'));
    }
    var o = options();
    var proprietes = {};
    proprietes[(o && o.propriete) || 'Prestation'] = avecMontage ? libelleMontage() : libelleRetrait();
    // La disponibilité voyage avec la ligne : sans elle, le client lit « sous 5 jours ouvrés » sur
    // le site puis ne la retrouve nulle part dans sa commande ni dans l'e-mail.
    var dispo = texteDisponibilite(avecMontage);
    if (o && o.proprieteDispo && dispo) proprietes[o.proprieteDispo] = dispo;
    var items = [{ id: product.variant_id, quantity: qte, properties: proprietes }];
    if (avecMontage && o && o.variantIdMontage) {
      items.push({ id: o.variantIdMontage, quantity: qte });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (res.ok) return data;
        // `description` est le message lisible renvoyé par Shopify (ex. rupture de stock).
        throw new Error((data && data.description) || 'Ajout au panier impossible pour le moment.');
      });
    });
  }

  function init() {
    var root = document.getElementById('pneus-resultats-root');
    if (!root) return;

    root.innerHTML = '<p class="pneus-resultats-loading">Chargement du catalogue…</p>';
    loadFullCatalogue(root, readCatalogue()).then(function (catalogue) {
      renderCatalogue(root, catalogue);
    });
  }

  function renderCatalogue(root, catalogue) {
    var dims = readParams();
    var hasDims = !!(dims.largeur && dims.hauteur && dims.diametre);

    var usedFallback = false;
    var baseResults = catalogue;
    if (hasDims) {
      // Ordre de relâchement : la dimension ne bouge jamais, les indices peuvent être supérieurs,
      // la saison se relâche en dernier — et seulement en le disant (bandeau ci-dessous).
      var compatibles = [];
      catalogue.forEach(function (p) {
        if (!matchesDimension(p, dims)) return;
        var compat = compatibiliteIndices(p, dims);
        if (!compat) return;
        p._compat = compat;
        compatibles.push(p);
      });
      var avecSaison = compatibles.filter(function (p) { return !dims.saison || p.saison === dims.saison; });
      if (avecSaison.length) {
        baseResults = avecSaison;
      } else {
        baseResults = compatibles;
        usedFallback = compatibles.length > 0;
      }
    }

    // Filtres ajustables par le client, initialisés depuis la dimension demandée — appliqués sur
    // baseResults (qui reste figé sur la dimension d'origine ; changer la saison ici ne relance
    // jamais une recherche sur une autre dimension, cf. lien "Modifier ma recherche").
    var filters = { marques: [], prixMax: null, saison: dims.saison || '' };
    var currentResults = [];

    function applyFilters() {
      var list = (hasDims ? baseResults : catalogue).slice();
      if (filters.saison) list = list.filter(function (p) { return p.saison === filters.saison; });
      if (filters.marques.length) list = list.filter(function (p) { return filters.marques.indexOf(p.marque) !== -1; });
      if (filters.prixMax != null) list = list.filter(function (p) { return (p.price || 0) / 100 <= filters.prixMax; });
      // Prix croissant, exacts et indices supérieurs mélangés : tout ce qui s'affiche est déjà
      // compatible, le client arbitre donc sur le prix. Un modèle courant à indice supérieur est
      // souvent moins cher qu'une référence exacte peu vendue.
      list.sort(function (a, b) { return (a.price || 0) - (b.price || 0); });
      return list;
    }

    function renderCard(p) {
      var prixUnitaire = (p.price || 0) / 100;
      var montageUnitaire = prixMontage(p);
      var nomChoix = 'mauto-choix-' + esc(p.id);
      var dispoTexte = texteDisponibilite(true);
      // Quantité par défaut : 2, comme sur la fiche produit. On ne vend quasiment jamais un seul
      // pneu, et les deux surfaces doivent proposer la même valeur.
      var qteDefault = dims.quantite === '4' ? '4' : '2';
      var indisponible = p.available === false;
      // La carte mène à la fiche produit : c'est là que vivent les badges, le détail du montage et
      // les visuels de gamme. `url` est sérialisé par pneus-resultats.liquid.
      var fiche = p.url || '';
      var img = p.image ? '<img class="pneus-card-image" src="' + esc(p.image) + '" alt="' + esc((p.marque || '') + ' ' + (p.modele || '')) + '" loading="lazy">' : '';
      var modele = esc(p.modele || p.title || '');
      return (
        '<div class="pneus-card" data-id="' + esc(p.id) + '">' +
          (img ? (fiche ? '<a class="pneus-card-media" href="' + esc(fiche) + '">' + img + '</a>' : img) : '') +
          '<div class="pneus-card-marque">' + esc(p.marque || '') + '</div>' +
          '<div class="pneus-card-modele">' +
            (fiche ? '<a class="pneus-card-lien" href="' + esc(fiche) + '">' + modele + '</a>' : modele) +
          '</div>' +
          '<div class="pneus-card-dimension">' + esc(p.largeur) + '/' + esc(p.hauteur) + ' R' + esc(p.diametre) +
            (p.indice_charge && p.indice_vitesse ? ' ' + esc(p.indice_charge) + esc(p.indice_vitesse) : '') +
            (p.saison ? ' — ' + esc(p.saison) : '') +
          '</div>' +
          (p._compat === 'superieur' ?
            '<button type="button" class="pneus-card-indices-sup" data-action="indices-info">Indices supérieurs — compatible ⓘ</button>' : '') +
          (p.etiquette_carburant || p.etiquette_adherence || p.etiquette_bruit ?
            '<div class="pneus-card-etiquettes">' +
              (p.etiquette_carburant ? '<span class="pneus-etiquette-badge" title="Consommation carburant">' + esc(p.etiquette_carburant) + '</span>' : '') +
              (p.etiquette_adherence ? '<span class="pneus-etiquette-badge" title="Adhérence sol mouillé">' + esc(p.etiquette_adherence) + '</span>' : '') +
              (p.etiquette_bruit ? '<span class="pneus-etiquette-badge" title="Bruit">' + esc(p.etiquette_bruit) + ' dB</span>' : '') +
            '</div>' : '') +
          '<div class="pneus-card-prix-row">' +
            '<div class="pneus-card-prix">' + euros(prixUnitaire) + ' <span class="pneus-card-prix-unite">/ pneu</span></div>' +
            (p.disponibilite ? '<div class="pneus-card-disponibilite">' + esc(p.disponibilite) + '</div>' : '') +
          '</div>' +
          // Le choix du client, sous le prix : montage coché par défaut, comme sur la fiche
          // produit. Deux boutons radio et non une case à cocher — les deux options doivent se
          // valoir visuellement, le client ne subit pas un décochage.
          '<div class="pneus-card-options" role="radiogroup" aria-label="Montage ou retrait seul">' +
            '<label class="pneus-card-option">' +
              '<input type="radio" name="' + nomChoix + '" value="montage" checked>' +
              '<span class="pneus-card-option-label">' + esc(libelleMontage()) + '</span>' +
              (montageUnitaire ? '<span class="pneus-card-option-prix">+ ' + euros(montageUnitaire) + ' / pneu</span>' : '') +
            '</label>' +
            '<label class="pneus-card-option">' +
              '<input type="radio" name="' + nomChoix + '" value="retrait">' +
              '<span class="pneus-card-option-label">' + esc(libelleRetrait()) + '</span>' +
              '<span class="pneus-card-option-prix">sans montage</span>' +
            '</label>' +
          '</div>' +
          // Date de disponibilité, pas un créneau : le rendez-vous précis se fixe plus tard. Rien
          // du tout si le fichier partagé n'a pas pu se charger — plutôt qu'un encadré vide.
          (dispoTexte ? '<div class="pneus-card-dispo" data-dispo>' + esc(dispoTexte) + '</div>' : '') +
          '<div class="pneus-card-actions">' +
            '<select class="pneus-card-qte" data-qte-select>' +
              ['2', '4'].map(function (q) { return '<option value="' + q + '"' + (q === qteDefault ? ' selected' : '') + '>' + q + '</option>'; }).join('') +
            '</select>' +
            // Rupture de stock : bouton neutralisé plutôt qu'un ajout qui se solderait par une
            // erreur Shopify. La dimension reste visible, le client voit qu'elle existe chez nous.
            '<button type="button" class="pneus-card-add" data-action="add"' + (indisponible ? ' disabled>Indisponible' : '>Ajouter') + '</button>' +
          '</div>' +
          (fiche ? '<a class="pneus-card-fiche" href="' + esc(fiche) + '">Voir la fiche</a>' : '') +
        '</div>'
      );
    }

    function wireCards() {
      var cards = root.querySelectorAll('.pneus-card');
      for (var i = 0; i < cards.length; i++) {
        (function (card) {
          var id = card.getAttribute('data-id');
          var product = currentResults.filter(function (p) { return String(p.id) === id; })[0];
          if (!product) return;
          var infoBtn = card.querySelector('[data-action="indices-info"]');
          if (infoBtn) {
            infoBtn.addEventListener('click', function () { ouvrirInfoIndices(product, dims); });
          }
          // Le choix montage/retrait ne change que ce que le client voit tant qu'il n'a pas
          // ajouté : la date de disponibilité change de formulation, rien ne part au panier.
          function avecMontage() {
            var coche = card.querySelector('input[value="retrait"]');
            return !(coche && coche.checked);
          }
          var ligneDispo = card.querySelector('[data-dispo]');
          var choix = card.querySelectorAll('input[type="radio"]');
          for (var r = 0; r < choix.length; r++) {
            choix[r].addEventListener('change', function () {
              if (ligneDispo) ligneDispo.textContent = texteDisponibilite(avecMontage());
            });
          }

          var boutonAjout = card.querySelector('[data-action="add"]');
          if (boutonAjout && !boutonAjout.disabled) {
            boutonAjout.addEventListener('click', function () {
              if (boutonAjout.disabled) return;
              var qte = parseInt(card.querySelector('[data-qte-select]').value, 10) || 2;
              var monte = avecMontage();
              var libelle = boutonAjout.textContent;
              // Désactivé le temps de l'appel : deux clics rapides ajouteraient deux fois.
              boutonAjout.disabled = true;
              boutonAjout.textContent = 'Ajout…';
              ajouterAuPanier(product, qte, monte).then(function () {
                afficherToast(qte + ' × ' + (product.marque || '') + ' ' + (product.modele || product.title || '') +
                  ' ajoutés au panier — ' + (monte ? 'montage compris' : 'retrait seul, sans montage'));
                // La pastille du panier est rendue par Liquid au chargement : sans ce
                // rafraîchissement elle continue d'annoncer l'ancien nombre, ce qui est pire
                // qu'une absence de pastille — le client croit son ajout perdu.
                if (window.MautoPanier) {
                  window.MautoPanier.rafraichirPastille();
                  // Mémorise la recherche en cours pour le lien « Continuer mes achats » du
                  // panier : sans elle, le client doit refaire sa dimension depuis le début.
                  window.MautoPanier.memoriserDimension(window.location.search);
                }
              }).catch(function (err) {
                afficherToast(err.message || 'Ajout au panier impossible pour le moment.', true);
              }).then(function () {
                boutonAjout.disabled = false;
                boutonAjout.textContent = libelle;
              });
            });
          }
        })(cards[i]);
      }
    }

    function wireFilters() {
      var checkboxes = root.querySelectorAll('[data-marque]');
      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].addEventListener('change', function (ev) {
          var m = ev.currentTarget.getAttribute('data-marque');
          if (ev.currentTarget.checked) filters.marques.push(m);
          else filters.marques = filters.marques.filter(function (x) { return x !== m; });
          render();
        });
      }
      var prixInput = root.querySelector('#pneus-filter-prix');
      if (prixInput) {
        // "change" (pas "input") : évite de perdre le focus/curseur à chaque frappe, le
        // re-rendu remplace tout root.innerHTML.
        prixInput.addEventListener('change', function () {
          var v = parseFloat(prixInput.value);
          filters.prixMax = isNaN(v) ? null : v;
          render();
        });
      }
      var saisonSelect = root.querySelector('#pneus-filter-saison');
      if (saisonSelect) {
        saisonSelect.addEventListener('change', function () {
          filters.saison = saisonSelect.value;
          render();
        });
      }
      // Renvoie au tiroir de recherche en haut de page. Si le tiroir n'a pas pu se charger
      // (index du catalogue indisponible), on retombe sur le parcours de devis plutôt que de
      // laisser un bouton qui ne fait rien.
      var versRecherche = root.querySelectorAll('[data-vers-recherche]');
      for (var v = 0; v < versRecherche.length; v++) {
        versRecherche[v].addEventListener('click', function (ev) {
          var tiroir = document.getElementById('pneus-recherche-dimension');
          if (tiroir && !tiroir.hidden) {
            if (ev.preventDefault) ev.preventDefault();
            tiroir.scrollIntoView({ behavior: 'smooth', block: 'start' });
            var premier = tiroir.querySelector('select');
            if (premier) setTimeout(function () { premier.focus(); }, 400);
          }
          // Sinon on laisse faire le lien : l'element porte un href de repli vers le devis.
        });
      }
    }

    function render() {
      currentResults = applyFilters();
      var marqueOptions = distinctMarques(hasDims ? baseResults : catalogue);
      // Même source que les marques : ce qui est réellement proposable pour cette recherche.
      var saisonOptions = saisonsDisponibles(hasDims ? baseResults : catalogue);
      var html = '';

      if (usedFallback) {
        html += '<div class="pneus-resultats-fallback-notice">Aucun pneu ' + (dims.saison ? esc(dims.saison) + ' ' : '') + 'exactement en ' + esc(dims.largeur) + '/' + esc(dims.hauteur) + ' R' + esc(dims.diametre) + ' — voici tous les pneus disponibles dans cette dimension, toutes saisons confondues.</div>';
      }

      if (!currentResults.length) {
        html +=
          // Renvoyer au tiroir de devis serait une boucle : le client en vient. On traite
          // l'absence de stock comme ce qu'elle est pour un garage — une commande — et on lui
          // évite de ressaisir sa dimension.
          '<div class="pneus-empty-state">' +
            (hasDims ?
              '<p class="pneus-empty-dim">' + esc(dims.largeur) + '/' + esc(dims.hauteur) + ' R' + esc(dims.diametre) +
                (dims.charge && dims.vitesse ? ' ' + esc(dims.charge) + esc(dims.vitesse) : '') + '</p>' +
              '<p>Nous ne l\'avons pas en stock — nous la commandons. Recevez votre prix sous 24 h.</p>' +
              '<a href="' + esc(lienCommande(dims)) + '">Demander cette dimension</a>'
              :
              '<p>Aucun pneu disponible pour cette recherche actuellement — contactez-nous pour un devis personnalisé, nous complétons le catalogue au fur et à mesure.</p>' +
              '<a href="/pages/devis-en-ligne">Demander un devis</a>'
            ) +
          '</div>';
        root.innerHTML = html;
        return;
      }

      html +=
        '<div class="pneus-resultats-layout">' +
          '<aside class="pneus-resultats-filters">' +
            // La dimension est rappelée EN TÊTE des filtres, parce que c'est elle qui commande
            // tout le reste : marque et prix ne se lisent qu'une fois la dimension fixée. Le
            // bouton renvoie au tiroir en haut de page plutôt que d'ouvrir un second formulaire,
            // pour qu'il n'existe qu'un seul endroit où l'on change de dimension.
            '<div class="pneus-filter-group pneus-filter-dimension">' +
              '<p class="pneus-filter-title">Dimension</p>' +
              (hasDims
                ? '<p class="pneus-filter-dimension-valeur">' + esc(dims.largeur) + '/' + esc(dims.hauteur) + ' R' + esc(dims.diametre) + '</p>' +
                  (dims.saison ? '<p class="pneus-filter-dimension-saison">' + esc(dims.saison) + '</p>' : '')
                : '<p class="pneus-filter-dimension-valeur pneus-filter-dimension-vide">Toutes dimensions</p>') +
              '<button type="button" class="pneus-filter-dimension-edit" data-vers-recherche>' +
                (hasDims ? 'Changer de dimension' : 'Choisir ma dimension') +
              '</button>' +
            '</div>' +
            '<div class="pneus-filter-group">' +
              '<p class="pneus-filter-title">Marque</p>' +
              marqueOptions.map(function (m) {
                return '<label class="pneus-filter-checkbox"><input type="checkbox" data-marque="' + esc(m) + '"' + (filters.marques.indexOf(m) !== -1 ? ' checked' : '') + '> ' + esc(m) + '</label>';
              }).join('') +
            '</div>' +
            '<div class="pneus-filter-group">' +
              '<p class="pneus-filter-title">Prix max (par pneu)</p>' +
              '<div class="pneus-filter-price-row"><input type="number" min="0" id="pneus-filter-prix" placeholder="Ex. 120" value="' + (filters.prixMax != null ? filters.prixMax : '') + '"> €</div>' +
            '</div>' +
            // Un seul choix réel de saison ne mérite pas de filtre : le menu n'offrirait que
            // « Toutes » et cette unique valeur, deux façons d'afficher exactement la même liste.
            (saisonOptions.length > 1 ?
              '<div class="pneus-filter-group">' +
                '<p class="pneus-filter-title">Saison</p>' +
                '<select class="pneus-filter-select" id="pneus-filter-saison">' +
                  '<option value="">Toutes</option>' +
                  saisonOptions.map(function (s) { return '<option value="' + esc(s) + '"' + (filters.saison === s ? ' selected' : '') + '>' + esc(s) + '</option>'; }).join('') +
                '</select>' +
              '</div>'
            : '') +
          '</aside>' +
          '<div class="pneus-resultats-main">' +
            '<p class="pneus-resultats-count">' + currentResults.length + ' pneu' + (currentResults.length > 1 ? 's' : '') + ' disponible' + (currentResults.length > 1 ? 's' : '') + '</p>' +
            '<div class="pneus-resultats-grid">' + currentResults.map(renderCard).join('') + '</div>' +
          '</div>' +
        '</div>';

      root.innerHTML = html;
      wireFilters();
      wireCards();
    }

    render();
  }

  // On attend DOMContentLoaded et pas seulement la fin du parsing : ce fichier est chargé par la
  // section, donc PLUS HAUT dans la page que assets/mauto-montage-pneu.js (chargé depuis le pied
  // de page). Démarrer plus tôt afficherait les cartes avant que window.MautoPneu n'existe, donc
  // sans la date de disponibilité. `demarre` évite un double démarrage si les deux événements
  // arrivent.
  var demarre = false;
  function demarrer() {
    if (demarre) return;
    demarre = true;
    init();
  }
  if (document.readyState === 'complete') {
    demarrer();
  } else {
    document.addEventListener('DOMContentLoaded', demarrer);
    window.addEventListener('load', demarrer);
  }
})();
